module.exports = __webpack_public_path__ + "static/media/sixanimation3.ea3406d9.gif";